import { IPlanData } from "../types";

export function getPurchaseData(plan?: IPlanData) {
  const tier = plan?.name ?? "Free";
  const price = (plan?.price || 0).toFixed(2);
  return { tier, price };
}
